export default[
    {
        path: '/internados',
        //name: 'ocupacion',
        component: () => import(/* webpackChunkName: "internados" */ '@/views/Internados.vue'),
        //meta: {
        //    requiresAuth: true,
        //    roles:['ROLE_PACIENTES'],
        //},
        children:[
            {
                path:'/',
                name:'InternamientosList',
                component: () => import(/* webpackChunkName: "InternamientosList" */ '@/views/internamientos/ListInternados.vue'),
                meta: {
                    requiresAuth: true,
                    roles:['ROLE_PACIENTES'],
                },
            },
            {
                path:'int/:id',
                name:'internamientoDetalle',
                component: () => import(/* webpackChunkName: "internamientoDetalle" */ '@/views/internamientos/InternamientoDetalle.vue'),
                meta: {
                    requiresAuth: true,
                    roles:['ROLE_PACIENTES'],
                },
            },
        ],
    }
]